import type { Asset } from "@/Dashboard/pages/AssetLibrary/types";

/**
 * Checks if a starting media item exists in the given media list,
 * optionally filtered by a content type ID or list of content type IDs.
 */
export function hasStartingMediaItemInCategory(
  mediaItems: Asset[] = [],
  startingAssetId: number | null,
  contentTypeId?: number | number[],
): boolean {
  return mediaItems.some((media) => {
    const isMatch = media.id === startingAssetId;
    if (Array.isArray(contentTypeId)) {
      return isMatch && contentTypeId.includes(media.contentTypeId);
    }
    return isMatch && (contentTypeId === undefined || media.contentTypeId === contentTypeId);
  });
}

/**
 * Checks if a starting media item exists across multiple category items,
 * using the mediaByCategory map, optionally filtered by content type ID(s).
 */
export function hasStartingMediaItemInList(
  items: { id: number }[],
  mediaByCategory: Record<number, Asset[]>,
  startingAssetId: number | null,
  contentTypeId?: number | number[],
): boolean {
  return items.some((item) => hasStartingMediaItemInCategory(mediaByCategory[item.id], startingAssetId, contentTypeId));
}
